import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const CollapseBar = styled.div<React.CSSProperties>`
  position: relative;
  background: #565656;
  top: 0;
  left: ${64 * Screen.widthRatio}px;
  width: ${1 * Screen.widthRatio}px;
  height: ${1080 * Screen.widthRatio}px;
`;

export default CollapseBar;
